import React from "react";
import PropTypes from "prop-types";

export default function Close({ color, ...props }) {
  return (
    <svg width={14} height={14} viewBox="0 0 14 14" {...props}>
      <g fill={color || "currentColor"} fillRule="nonzero" stroke={color || "currentColor"}>
        <path d="M1.25 13a.246.246 0 0 0 .177-.076l5.5-5.74a.27.27 0 0 0 0-.368l-5.5-5.74a.243.243 0 0 0-.354 0 .27.27 0 0 0 0 .37L6.396 7l-5.323 5.554a.27.27 0 0 0 0 .37.242.242 0 0 0 .177.076z" />
        <path d="M12.75 1a.246.246 0 0 0-.177.076l-5.5 5.74a.27.27 0 0 0 0 .368l5.5 5.74a.243.243 0 0 0 .354 0 .27.27 0 0 0 0-.37L7.604 7l5.323-5.554a.27.27 0 0 0 0-.37A.242.242 0 0 0 12.75 1z" />
      </g>
    </svg>
  );
}

Close.propTypes = {
  color: PropTypes.string,
};

Close.defaultProps = {
  color: null,
};
